import {
  Page, Section, SubSection, ElementType, EventType,
} from './constants';

export const AccountInputsEvents = {
  usernameCompleted: () => ({
    event: 'username completed',
    properties: {
      page: Page.accountInputs,
      section: Section.letsGetStarted,
      elementType: ElementType.input,
      eventType: EventType.blur,
    },
  }),
  passwordCompleted: () => ({
    event: 'password completed',
    properties: {
      page: Page.accountInputs,
      section: Section.letsGetStarted,
      elementType: ElementType.input,
      eventType: EventType.blur,
    },
  }),
  confirmPasswordCompleted: () => ({
    event: 'confirm password completed',
    properties: {
      page: Page.accountInputs,
      section: Section.letsGetStarted,
      elementType: ElementType.input,
      eventType: EventType.blur,
    },
  }),
  emailAddressCompleted: () => ({
    event: 'email address completed',
    properties: {
      page: Page.accountInputs,
      section: Section.letsGetStarted,
      elementType: ElementType.input,
      eventType: EventType.blur,
    },
  }),
  recaptchaCompleted: isValid => ({
    event: 'recaptcha completed',
    properties: {
      page: Page.accountInputs,
      section: Section.letsGetStarted,
      subSection: SubSection.recaptcha,
      elementType: ElementType.captcha,
      isValid,
    },
  }),
  termsOfServiceAccepted: () => ({
    event: 'terms of service accepted',
    properties: {
      page: Page.accountInputs,
      section: Section.letsGetStarted,
      elementType: ElementType.checkbox,
      eventType: EventType.click,
    },
  }),
  termsOfServiceClicked: () => ({
    event: 'terms of service clicked',
    properties: {
      page: Page.accountInputs,
      section: Section.letsGetStarted,
      elementType: ElementType.link,
      eventType: EventType.click,
    },
  }),
  privacyPolicyClicked: () => ({
    event: 'privacy policy clicked',
    properties: {
      page: Page.accountInputs,
      section: Section.letsGetStarted,
      elementType: ElementType.link,
      eventType: EventType.click,
    },
  }),
  accountCreated: () => ({
    event: 'account created',
    properties: {
      page: Page.accountInputs,
      section: Section.letsGetStarted,
    },
  }),
  overageRatesClicked: () => ({
    event: 'overage rates clicked',
    properties: {
      page: Page.accountInputs,
      section: Section.yourProducts,
      subSection: SubSection.totalPrice,
      elementType: ElementType.link,
      eventType: EventType.click,
    },
  }),
};
